var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import EventEmitter from "./EventEmitter";
var Resources = /** @class */ (function (_super) {
    __extends(Resources, _super);
    function Resources(_sources) {
        var _this = _super.call(this) || this;
        _this.sources = _sources;
        _this.items = {};
        _this.toLoad = _this.sources.length;
        _this.loaded = 0;
        _this.setLoaders();
        _this.startLoading();
        return _this;
    }
    Resources.prototype.setLoaders = function () {
        this.loaders = {};
        this.loaders.gltfLoader = new GLTFLoader();
        this.loaders.textureLoader = new THREE.TextureLoader();
        this.loaders.cubeTextureLoader = new THREE.CubeTextureLoader();
    };
    Resources.prototype.startLoading = function () {
        var _this = this;
        // Load each source
        if (!this.sources || !this.sources.length) {
            setTimeout(function () {
                _this.trigger("ready");
            }, 0);
            return;
        }
        var _loop_1 = function (source) {
            if (source.type === "gltfModel") {
                this_1.loaders.gltfLoader.load(source.path, function (file) {
                    _this.sourceLoaded(source, file);
                });
            }
            else if (source.type === "texture") {
                this_1.loaders.textureLoader.load(source.path, function (file) {
                    _this.sourceLoaded(source, file);
                });
            }
            else if (source.type === "cubeTexture") {
                this_1.loaders.cubeTextureLoader.load(source.path, function (file) {
                    _this.sourceLoaded(source, file);
                });
            }
        };
        var this_1 = this;
        for (var _i = 0, _a = this.sources; _i < _a.length; _i++) {
            var source = _a[_i];
            _loop_1(source);
        }
    };
    Resources.prototype.sourceLoaded = function (source, file) {
        this.items[source.name] = file;
        this.loaded++;
        if (this.loaded === this.toLoad) {
            this.trigger("ready");
        }
    };
    return Resources;
}(EventEmitter));
export default Resources;
